import React from 'react'

export type ActiveDragKind = 'group' | 'task' | null

export type DragState = {
  kind: ActiveDragKind
  sourceGroupName: string | null
  overGroupName: string | null
}

export const DragStateContext = React.createContext<DragState>({
  kind: null,
  sourceGroupName: null,
  overGroupName: null,
})
